import '../uploader.js';

export class Code {
    constructor() {
        this.submitButton = document.querySelector('button[type=submit]');
        this.code = document.querySelector('input[name="staticpage[code]"]');

        this.init();
    };

    init() {
        if (this.submitButton) {
            this.submitButton.addEventListener('click', () => {
                this.submitCode();
            });
        }
    };

    submitCode() {
        let request = new Request('POST', document.location.pathname + '/code');
        request.data = {
            code: this.code.value,
        };

        request.call(data => {
            if(data.status == 'ok') {
                window.location.href = document.location.pathname;
            } else {
                OVS.app.helper.removeClass('.error', 'd-none');
            }
        });
    };

    resetValidation() {
        let errors = document.querySelectorAll('.form-error');
        let labels = document.querySelectorAll('label');

        if(errors) {
            errors.forEach(element => {
                element.classList.add('d-none');
            });
        }

        if(labels) {
            labels.forEach(element => {
                element.classList.remove('text-danger');
            });
        }
    };
};
